import React, { useState, useRef, useCallback, useEffect } from 'react'
import Picker from './Picker'
import DateRange from './DateRange'
import { Overlay } from 'react-bootstrap'
import { StyledPopover } from './DateRangePicker.style'
import { DATE_MOMENT_FORMAT } from 'utils/constants'
import moment from 'moment'
import { kebabCase } from 'lodash'
import { isEmpty } from 'lodash'

const DateRangePicker = ({ onChange, value, label, showDefaultValues = false }) => {
  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null)
  const ref = useRef(null)
  const [range, setRange] = useState()

  useEffect(() => {
    setRange(value)
  }, [value])

  const handleClick = useCallback(
    (event) => {
      setShow(value => !value)
      setTarget(event.target)
    },
    [setShow, setTarget]
  )

  const handleOnChange = useCallback(
    (range) => {
      const [range1, range2] = range || []
      //Remove empty ranges
      const newRange = [range1, range2]?.filter((r) => r?.some(element => element))
      setShow(false)
      onChange(isEmpty(newRange) ? null : newRange)
      setRange(isEmpty(newRange) ? null : newRange)
    },
    [setShow, onChange, setRange]
  )

  const renderSelectedValue = ([from, to]) => (
    <div>
      {!from && 'On or Before '}
      {!to && 'On or After '}
      {from && <span>{moment(from).format(DATE_MOMENT_FORMAT)}</span>}
      {to && from && ' - '}
      {to && <span>{moment(to).format(DATE_MOMENT_FORMAT)}</span>}
    </div>
  )

  return (
    <>
      <Picker
        active={!!range}
        onOpen={handleClick}
        onClose={() => handleOnChange(null)}
        label={label}
      />
      <div>
        {range?.map((r, ix) => (
          <div className="small mb-1" key={`${kebabCase(r)}-${ix}`}>
            {renderSelectedValue(r)}
          </div>
        ))}
      </div>

      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref.current}
        rootClose
        rootCloseEvent="click"
        onHide={() => setShow(false)}
      >
        <StyledPopover id={`popover-positioned-bottom`}>
          <StyledPopover.Content>
            <DateRange
              onChange={handleOnChange}
              value={value}
              onCancel={() => setShow(false)}
              {...{ showDefaultValues }}
            />
          </StyledPopover.Content>
        </StyledPopover>
      </Overlay>
    </>
  )
}

export default DateRangePicker
